import { Localization } from "./i18n/types";
import { ColorMode } from "./types";

export const zIndex = {
  top: 99999,
  high: 9999,
  middle: 1200,
  low: 1,
  base: 0,
} as const;

export const DEFAULT_ISO639_1: Localization = "en" as const;
export const DEFAULT_COLOR_MODE: ColorMode = "dark" as const;
export const DEFAULT_SHOW_EMPTY_DATES: boolean = false as const;
export const DEFAULT_RECEIVE_NEW_RESERVATION_EMAILS: boolean = true as const;
export const DEFAULT_RECEIVE_UPDATED_RESERVATION_EMAILS: boolean =
  true as const;
export const DEFAULT_RECEIVE_CANCELLED_RESERVATION_EMAILS: boolean =
  true as const;
export const DEFAULT_FIRST_DAY_OF_WEEK: string = "sunday" as const;
